import { getClusterColor } from './colors';
export function curatorRasterTraces(units, sampleRateHz, names = {}) {
  if (!(sampleRateHz > 0)) return [];
  return units.map((unit, index) => ({
    type: 'scattergl', mode: 'markers', name: names[unit.id] || `Unit ${unit.id}`,
    x: unit.spikeTimes.map(time => time / sampleRateHz), y: unit.spikeTimes.map(() => index),
    marker: { color: getClusterColor(unit.id), symbol: 'line-ns', size: 7, line: { width: 1 } },
    hovertemplate: 'Time: %{x:.4f} s<extra>%{fullData.name}</extra>', showlegend: false,
  }));
}
